import styled from 'styled-components'
import { InstantSearch } from 'react-instantsearch'
import searchClient from '../../services/search/clients/search'
import SearchBox from './search-box'
import SearchResults from './search-results'

const SearchContainer = styled.div`
  height: 100%;
`

const Search = ({
  config,
  onClose,
  rounded = false,
}) => {
  const { placeholder, indexes, closeSearch } = config

  return (
    <SearchContainer>
      <InstantSearch
        indexName={indexes[0]}
        searchClient={searchClient}
        insights
        future={{
          preserveSharedStateOnUnmount: true,
        }}
      >
        <SearchBox
          placeholder={placeholder}
          closeSearch={closeSearch}
          rounded={rounded}
          onClose={onClose}
        />

        <SearchResults rounded={rounded} indexes={indexes} />
      </InstantSearch>
    </SearchContainer>
  )
}

export default Search
